import React from 'react';
import {breakpoints, calcRem, css, respondTo, styled, transitionDefault } from '~/styles';
import { ReactSVG } from 'react-svg';


import modeList from '~/assets/images/gallery-mode-list.svg';
import modeGrid from '~/assets/images/gallery-mode-grid.svg';

const StyledViewMode = styled.div`
  justify-self: flex-end;
  flex: 0 0 0;
  display: flex;
  flex-flow: row;
  justify-content: flex-end;

  ${respondTo(breakpoints.md, css`
    display: none;
  `)};
`

const ViewModeButton = styled.button`
  flex: 0 0 ${calcRem(50)};
  height: ${calcRem(50)};
  margin: 0 !important;

  &:not(.active) {
    cursor: pointer;
  }

  &:not(:first-of-type) {
    margin-left: -2px !important;
  }

  svg {
    width: ${calcRem(50)};
    height: ${calcRem(50)};

    path {
      ${transitionDefault};
      transition-property: stroke, fill;
    }
  }

  &:hover:not(.active) {
    .part-outside {
      fill: rgba(255, 255, 255, 0.15);
    }
  }
`

const ViewModeButtonList = styled(ViewModeButton)`
  &.active {
    .part-outside {
      fill: white;
    }
    .part-inside {
      fill: black;
      stroke: black;
    }
  }
`

const ViewModeButtonGrid = styled(ViewModeButton)`
  &.active {
    .part-outside {
      fill: white;
    }
    .part-inside {
      fill: black;
    }
  }
`

interface Props {
  gridModeSelected: boolean;
  onGridModeSelected: (state: boolean) => void;
}
const ResourcesViewModeSelector: React.FC<Props> = ({ gridModeSelected, onGridModeSelected }) => {

  return (
    <StyledViewMode>
      <ViewModeButtonList onClick={() => onGridModeSelected(false)} 
        className={`${gridModeSelected ? '' : 'active'}`}>
        <ReactSVG alt='List' src={modeList} />
      </ViewModeButtonList>
      <ViewModeButtonGrid onClick={() => onGridModeSelected(true)} 
        className={`${gridModeSelected ? 'active' : ''}`}>
        <ReactSVG alt='Grid' src={modeGrid} />
      </ViewModeButtonGrid>
    </StyledViewMode>
  )
}
export default ResourcesViewModeSelector;



// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourcesViewModeSelector.tsx